<template>
    <section class="container" style="margin: 2% auto">
        <div id="sales-stats">
            <h1 class="title">Orders Stats</h1>
            <h6 class="subtitle">From {{(new Date(stats.startDate)).toLocaleDateString()}} to {{(new Date(stats.endDate)).toLocaleDateString()}}</h6>

            <hr/>
            <nav class="level">
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Sales USD</p>
                        <p class="title">{{ stats.paid.usd_total | money}}</p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                        <p class="heading">Sales ZWD</p>
                        <p class="title">{{ stats.paid.total | money }}</p>
                    </div>
                </div>
            </nav>
            <hr/>
            <h6 class="subtitle">Sales Trend</h6>
        </div>
        <div class="columns is-mobile" id="sales">
            <div class="column" id="sales-trends">
                <trend
                    :data="dailyTotals"
                    :gradient="['#6fa8dc', '#42b983', '#2c3e50']"
                    auto-draw
                    smooth>
                </trend>            
            </div>
            <div class="column">
                <b-table
                :data="dailySales">
                    <template slot-scope="props">
                        <b-table-column field="date" label="Date">
                            {{ props.row.date }}
                        </b-table-column>

                        <b-table-column field="daySales" label="Sales (USD)">
                            {{ props.row.usd_total | money }} 
                            <!-- {{ props.row.total | money }} -->
                        </b-table-column>
                    </template>
                    
                </b-table>
                
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "OrderStats",
    data() {
        return {
            stats: {
                paid: {
                    total: 0,
                    usd_total: 0,
                    percentage: 0,
                    count: 0
                },
                created: {
                    potential_total: 0,
                    potential_usd_total: 0,
                    count: 0,
                    percentage: 0
                },
                startDate: "",
                endDate: ""
            }
        }
    },
    computed: { 
        dailyTotals() {
            return (this.stats && this.stats.paid) ? Object.values(this.stats.paid.usd_daily_totals).reverse() : []; 
        },
        dailySales() {
            return (this.stats && this.stats.paid) ? Object.keys(this.stats.paid.usd_daily_totals).map(date=> {
                return {
                    date,
                    total: this.stats.paid.daily_totals[date],
                    usd_total: this.stats.paid.usd_daily_totals[date]
                }
            }) : []
        }
    },
    created() {
        this.getOrderStats();
    },
    methods: {
        getOrderStats() {
            this.$store.dispatch('getOrderStats').then(stats=> {
                this.stats = stats;
                this.$toasted.global.success('Stats Loaded.')
            }).catch(e=> {
                console.log(`Exception when getting order stats`,e);
                this.$toasted.global.error(`Failed to get Order Stats`);
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/EquipmentRequests/Stats.vue